var _excluded = ["caption", "onDelete", "src", "uploading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CloseIcon from '@material-ui/icons/Close';
import GalleryDragHandle from './GalleryDragHandle';
import GalleryImage from './GalleryImage';
import { StyledGalleryImageAction } from './GalleryImage.styled';
function SortableGalleryImage(_ref) {
  var caption = _ref.caption,
    onDelete = _ref.onDelete,
    src = _ref.src,
    uploading = _ref.uploading,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useSortable = useSortable({
      id: src
    }),
    args = _useSortable.arguments,
    isSorting = _useSortable.isSorting,
    isDragging = _useSortable.isDragging,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    setDraggableNodeRef = _useSortable.setDraggableNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var styles = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  var otherProps = _extends({
    caption: caption,
    src: src,
    uploading: uploading
  }, rest);
  var actions = function actions() {
    if (!uploading && !isDragging) {
      return /*#__PURE__*/React.createElement(StyledGalleryImageAction, null, /*#__PURE__*/React.createElement(GalleryDragHandle, _extends({}, args, listeners, {
        ref: setDraggableNodeRef
      })), onDelete && /*#__PURE__*/React.createElement(IconButton, {
        color: "secondary",
        size: "small",
        disableFocusRipple: true,
        disableRipple: true,
        onClick: onDelete
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        fontSize: "small"
      })));
    }
    return undefined;
  };
  return /*#__PURE__*/React.createElement(GalleryImage, _extends({
    ref: setNodeRef,
    style: styles,
    dragging: isDragging,
    sorting: isSorting,
    actions: actions()
  }, otherProps));
}
SortableGalleryImage.propTypes = process.env.NODE_ENV !== "production" ? {
  caption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onDelete: PropTypes.func,
  src: PropTypes.string.isRequired,
  uploading: PropTypes.bool
} : {};
SortableGalleryImage.defaultProps = {
  caption: undefined,
  onDelete: undefined,
  uploading: false
};
export default SortableGalleryImage;